import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-auth-message',
  templateUrl: './auth-message.component.html',
  styleUrls: ['../../shared/css/auth.css', './auth-message.component.css'],
})

export class AuthMessageComponent {
  constructor(public router: Router) {}

  signUpToday() {
    this.router.navigate(['/register-user']);
  }
}
